<template>
  <div>
    <div class="relative mr-5">
      <span
        class="icon-user align-middle text-3xl dark:text-white cursor-pointer leading-none"
        :title="$t('titles.userMenu')"
        :class="
          currentPage === 'Login' ? 'text-nucleus-white' : 'text-nucleus-grey'
        "
        @click="toggleMenu()"
      >
      </span>
      <div
        v-if="menu"
        v-click-away="toggleMenu"
        class="fixed z-20 top-header right-0 text-right"
      >
        <div class="bg-nucleus-white shadow-lg p-4">
          <div class="font-bold">{{ user.attributes.name }}</div>
          <div class="border-b pb-3 mb-3">{{ user.attributes.email }}</div>
          <!-- <div class="py-2 cursor-pointer">Account Settings</div> -->
          <div class="py-2 cursor-pointer" @click="logout()">
            {{ $t("global.defaults.logOut") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { Auth } from "aws-amplify";
import router from "@/router";

@Options({
  data() {
    return {
      menu: false,
    };
  },
  props: {
    currentPage: String,
  },
  computed: {
    user() {
      return this.$store.getters.getUserObject;
    },
  },
  methods: {
    toggleMenu() {
      this.menu = this.menu ? false : true;
    },
    async logout() {
      try {
        await Auth.signOut();
        this.toggleMenu();
        this.removeAccess();
        router.go(0);
      } catch (err) {
        console.log("ERROR", err);
      }
    },

    removeAccess() {
      this.$store.dispatch("setUserObject", null);
      this.$store.dispatch("setRoles", []);
    },
  },
})
export default class UserMenu extends Vue {}
</script>
